/// <reference path="../classes/User.ts"/>
module App.Interfaces {
    export interface IEncryptionService {
        decrypt(message: string) : string;
    }
}